import React, {useEffect, useState} from 'react';
import stl from './TipAndReview.module.css';
import TipAmountInput from "../../atoms/TipAmountInput";
import TipAmountSelector from "../../molecules/TipAmountSelector";
import EmojiSelector from "../../molecules/EmojiSelector";
import RatingSlider from "../../molecules/RatingSlider";
import ReviewBox from "../../molecules/ReviewBox";
import PaymentAndAgreementOptions from "../../molecules/PaymentAndAgreementOptions";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import { Timestamp } from "firebase/firestore";
import {Preloader} from "../../atoms/Preloader";
import { v4 as uuidv4 } from 'uuid';
import {logEvent, registerUser} from "../../amplitude";
import getGuestId from "../../storage/getGuestId";
import * as amplitude from "@amplitude/analytics-browser";
import api from "../../api/api";

const TipAndReview = () => {
    const location = useLocation();
    const { serviceId } = useParams();
    const guestId = getGuestId();

    const navigate = useNavigate();
    const storedData = JSON.parse(localStorage.getItem('body'));
    const storedBody = storedData?.service_id === serviceId ? storedData : false
    const [employeeData, setEmployeeData] = useState(location?.state?.employee || null);
    const { description, name, image_url, price, amounts, question } = employeeData || {};
    const [amount, setAmount] = useState(storedBody?.amount || (price / 100).toFixed(2));
    const [answers, setAnswers] = useState(storedBody?.answers || [null, null, null]);
    const [pRating, setPRating] = useState(storedBody?.p_rating || null);
    const [review, setReview] = useState(storedBody?.review || '');
    const [rating, setRating] = useState(storedBody?.rating || 1);
    const [commissionChecked, setCommissionChecked] = useState(true);
    const [termsChecked, setTermsChecked] = useState(true);
    const [loading, setLoading] = useState(true);
    const [fee, setFee] = useState(0);
    const [tiponFee, setTiponFee] = useState(0);
    const [stripeFee, setStripeFee] = useState(0);
    const [isManualInput, setIsManualInput] = useState(false);

    const fetchServiceData = async (serviceId) => {
        try {
            const { data } = await api.post('/rpc/get_service', {
                p_id_external: serviceId,
            });

            if (data) {
                setEmployeeData(data);
                setAmount(storedBody?.amount || (data.price / 100).toFixed(2));
            } else {
                console.error('Данные сервиса не найдены.');
            }
        } catch (error) {
            console.error('Ошибка при получении данных сервиса: ', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!employeeData && serviceId) {
            fetchServiceData(serviceId);
        } else {
            setLoading(false)
        }
    }, [employeeData, serviceId]);

    useEffect(() => {
      const newFee = (amount * 0.029 + 0.30 + amount * 0.06).toFixed(2)
      const newTiponFee = (amount * 0.06).toFixed(2)
      const newStripeFee = (amount * 0.029 + 0.30).toFixed(2)
        setFee(Number(newFee))
        setTiponFee(Number(newTiponFee) * 100)
        setStripeFee(Number(newStripeFee) * 100)
    }, [amount]);

    useEffect(() => {
        if (employeeData) {
            logEvent("Page view", {
                Title: 'Main',
                Path: location.pathname,
                URL: window.location.href,
                'Tips default ': (price / 100).toFixed(2),
                'Employee ID': employeeData?.service_id,
                'Service description enabled': !!employeeData?.description,
                'Service question enabled': question?.length > 0,
                'Guest ID': guestId,
            });
            registerUser(employeeData?.user?.email)
        }
    }, [employeeData]);
    // Логируем изменение чаевых
    useEffect(() => {
        if (storedBody?.amount !== amount) {
            logEvent("Tips changed", {
                'Tips default': storedBody?.amount || (price / 100).toFixed(2),
                'Tips amount': amount,
                'Tips changed by': isManualInput ? "input" : "preselection",
                'Guest ID': guestId,
            });
        }
    }, [amount, isManualInput]);

    const handleRatingChange = (newRating) => {
        setRating(newRating);
        logEvent("Order rated", {
            Answer: newRating === 0 ? "bad" : newRating === 1 ? "good" : "amazing",
            'Guest ID': guestId,
        });
    };

    const onSetAnswer = (answer, index) => {
        logEvent("Question answered", {
            Answer: answer === 0 ? "bad" : answer === 50 ? "good" : "amazing",
            Number: index,
            Title: question[index],
            'Guest ID': guestId,

        });
        setAnswers(prevAnswers => {
            const newAnswers = [...prevAnswers];
            newAnswers[index] = answer;
            return newAnswers;
        });
    }
    // Логируем изменение отзыва
    useEffect(() => {
        if (storedBody?.review !== review) {
            logEvent("Review added", {
                review: review,
                'Guest ID': guestId,
            });
            const reviewsCount = new amplitude.Identify();
            reviewsCount.add('Reviews count', 1);
            amplitude.identify(reviewsCount);
        }
    }, [review]);

    // Логируем Нажата галочка комиссии
    const handleCommissionCheckedChange = (newValue) => {
        setCommissionChecked(newValue);
        logEvent("Processing fee checked", {
            Checked: newValue,
            Fee: fee || 0,
            'Guest ID': guestId,
        });
    };
    // Логируем Нажата галочка условий
    const handleTermsCheckedChange = (newValue) => {
        setTermsChecked(newValue);
        console.log(newValue, 'newValueLegal');
        logEvent("Legal checked", {
            Checked: newValue,
            'Guest ID': guestId,
        });
    };

    const handleAmountChange = (newAmount, method = "input") => {
        setAmount(newAmount);
        setIsManualInput(method === "input"); // true, если ручной ввод
    };

    const transformAnswers = (answers, questions) =>
        answers?.reduce((acc, val, index) => {
            if (val === null || !questions?.[index]) return acc;
            const normalized = val === 100 ? 3 : val === 50 ? 2 : 1;
            acc.push({ question: questions[index], answer: normalized });
            return acc;
        }, []);

    const sendReview = async ({ serviceId, review, reaction, pRating, answers, questions }) => {
        try {
            console.log(serviceId, 'serviceId');
            const payload = {
                p_id_external: serviceId,
                p_comment: review,
                p_reaction: reaction,
                p_rating: pRating,
                p_answers: transformAnswers(answers, questions),
            };

            await api.post('/rpc/create_review', payload);
            console.log('Отзыв успешно отправлен');
        } catch (error) {
            console.error('Ошибка при отправке отзыва:', error);
        }
    };
    console.log(amount,'amount')
    console.log(fee,'fee')
    console.log(tiponFee,'tiponFee')
    console.log(stripeFee,'stripeFee')
    console.log(commissionChecked,'commissionChecked')
    console.log(+((Number(commissionChecked ? fee : 0) + Number(amount)).toFixed(2)),'(Number(commissionChecked ? fee : 0) + Number(amount)).toFixed(2)')

    const onPay = async () => {
        logEvent("To payment pressed", {
            'Button type': 'to payment',
            Amount: amount,
            Fee: fee,
            'Guest ID': guestId,
        });

        const currentDate = new Date();
        const timestamp = Timestamp.fromDate(currentDate);

        const body = {
            amount: +((Number(commissionChecked ? fee : 0) + Number(amount)).toFixed(2)),
            answers,
            name,
            rating,
            pRating,
            review,
            serviceId,
            fee,
            tiponFee,
            stripeFee,
            connected_account_id: employeeData?.connected_account_id,
            datetime: timestamp,
            id: uuidv4(),
            user: `/users/${employeeData?.user?.uid}`,
            description: employeeData.name,
            mode: employeeData?.env,
            commissionChecked,
            photo: image_url,
            questions: question,
        };
        console.log(body, 'body')
        // Сохраняем в localStorage
        localStorage.setItem('body', JSON.stringify(body));

        // Отправка отзыва
        await sendReview({
            serviceId: serviceId,
            review,
            reaction: rating,
            pRating: pRating === 0 ? 1 : pRating === 50 ? 2 : pRating === 100 ? 3 : pRating,
            answers,
            questions: question,
        });


        // Переход на страницу оплаты
        navigate('/payment', {
            state: {
                product: location?.state?.employee,
                feedback: body
            }
        });
    };

    if (loading) return <Preloader/>
    return (
        <div className={stl.container}>
            <div className={stl.containerInner}>
                <div className={stl.personInfoContainer}>
                    <div className={stl.personInfoBox}>
                        <img src={image_url} alt='personImg' className={stl.personImg} />
                        <div className={stl.personContent}>
                            <h4 className={stl.personName}>{name}</h4>
                            <p className={stl.personGoal}>{description}</p>
                        </div>
                    </div>
                </div>
                <div className={stl.tipInputBox}>
                    <TipAmountInput setAmount={(val) => handleAmountChange(val, "input")} amount={amount} />
                </div>
                <p className={stl.tipHint}>or select the appropriate amount</p>
                <TipAmountSelector amounts={amounts} onSelectAmount={(val) => handleAmountChange(val, "preselection")}/>
                <h2 className={stl.tipTitle}>How was it ?</h2>
                <EmojiSelector onClick={handleRatingChange} initialEmojiIndex={rating}/>
                <div className={stl.ratingSliderBox}>
                    <RatingSlider
                        initialValue={pRating || 25.50}
                        title={'Please rate the quality of service'}
                        onValueChange={(value) => setPRating(value)}
                        labels={['⭐', '⭐⭐', '⭐⭐⭐']}
                    />
                </div>
                <div className={stl.ratingSliderBox}>
                    {question?.length > 0 && question.map((qst, index) => {
                        return (
                            <RatingSlider
                                initialValue={answers?.[index] || 25.50}
                                key={`question-${index}`}
                                title={qst}
                                onValueChange={(answer) => onSetAnswer(answer, index)}/>
                        )
                    })
                    }
                    <ReviewBox onChange={setReview} value={review}/>
                </div>
                <div>
                    <PaymentAndAgreementOptions onPay={onPay} commissionChecked={commissionChecked}
                                                setCommissionChecked={handleCommissionCheckedChange} fee={fee} amount={amount}
                                                setTermsChecked={handleTermsCheckedChange} termsChecked={termsChecked}/>
                </div>
            </div>
        </div>
    );
};

export default TipAndReview;
